module.exports = __webpack_public_path__ + "img/guo-b.6fb50876.png";